import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { QuickViewComponent } from "../../components/modal/quick-view/quick-view.component";
import { CartModalComponent } from "../../components/modal/cart-modal/cart-modal.component";
import { Product } from "../../classes/product";
import { ProductService } from "../../services/product.service";
import { FirestoreService } from '../../services/firestore.service';


@Component({
  selector: 'app-product-box-six',
  templateUrl: './product-box-six.component.html',
  styleUrl: './product-box-six.component.scss'
})
export class ProductBoxSixComponent implements OnInit {


  @Input() product: Product;
  @Input() currency: any = this.productService.Currency; // Default Currency
  @Input() cartModal: boolean = false; // Default False
  user:any;
  
  @ViewChild("quickView") QuickView: QuickViewComponent;
  @ViewChild("cartModal") CartModal: CartModalComponent;

  constructor(private productService: ProductService, private firestoreService: FirestoreService) {
   }

  ngOnInit(): void {
  }


  addToCart(product: any) {
    this.productService.addToCart(product);
  }

  addToWishlist(product: any) {
    this.productService.addToWishlist(product);
  }

  addToCompare(product: any) {
    this.productService.addToCompare(product);
  }

}
